var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{staticClass:"border-999",attrs:{"controls":"controls","preload":"auto","poster":_vm.imgUrl,"playsinline":"true","x5-video-orientation":"portraint","src":_vm.url,"height":"auto","width":_vm.videoSize}})])
}
var staticRenderFns = []

export { render, staticRenderFns }